import { Component, OnInit, ViewChild } from '@angular/core';
import { FiltroListaPedidoCompra } from '../filter/filtro-lista-pedido-compra';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageAction, PoPageFilter, PoSearchFilterMode, PoTableAction, PoTableColumn } from '@po-ui/ng-components';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { PedidoCompraService } from '../service/pedido-compra.service';
import { PedidoCompraEnviarEmailFornecedor, PedidoCompraListaItem, defaultPedidoCompraEnviarEmailFornecedor } from '../interface/pedido-compra';
import { UsuarioLookupService } from 'src/app/service/usuario-lookup-service';
import { FornecedorLookupService } from 'src/app/service/fornecedor-lookup-service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-pedido-compra-lista',
  templateUrl: './pedido-compra-lista.component.html',
  styleUrl: './pedido-compra-lista.component.css'
})
export class PedidoCompraListaComponent implements OnInit {

  tabelaPrincipalItens: Array<PedidoCompraListaItem> = [];
  tabelaPrincipalFiltro: FiltroListaPedidoCompra;
  tabelaPrincipalShowMoreDisable: boolean = true;
  tabelaPrincipalHeight: number =  window.innerHeight - 330;

  pcEnviarEmailFornecedor: PedidoCompraEnviarEmailFornecedor = defaultPedidoCompraEnviarEmailFornecedor();

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  usuarioColumnsFilters: Array<PoLookupColumn> = this.usuarioLookupService.getColumnsFilter();
  fornecedorColumnsFilters: Array<PoLookupColumn> = this.fornecedorLookupService.getColumnsFilter();

  breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)},
      {label: 'Pedido de Compra'},
    ],
  };

  actionPage: Array<PoPageAction> = [
    {label: 'Novo Pedido', action: this.novaPedidoCompra.bind(this)}
  ]

  constructor(
    private router: Router,
    private poDialogService: PoDialogService,
    private poNotificationService: PoNotificationService,
    private pedidoCompraService: PedidoCompraService,
    private authService: AuthService,
    public usuarioLookupService: UsuarioLookupService,
    public fornecedorLookupService: FornecedorLookupService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroListaPedidoCompra(authService,'filtro-lista-pedido-compra');
    this.tabelaPrincipalFiltro.dados.order = 'C7_NUM desc'

  }

  @ViewChild('advancedFilterModal', {static: true}) advancedFilterModal!: PoModalComponent;
  @ViewChild('enviarEmailFornecedorModal', {static: true}) enviarEmailFornecedorModal!: PoModalComponent;


  async ngOnInit() {
    this.tabelaPrincipalFiltro.init().then(()=>{
      this.advancedFilterActionModal();
    });
  }

  tabelaPrincipalLoad(zerarPaginacao: boolean):void{

    if (zerarPaginacao){
      this.tabelaPrincipalFiltro.dados.page = 1;
      this.tabelaPrincipalItens = [];
    } else {
      this.tabelaPrincipalFiltro.dados.page++;
    }

    this.tabelaPrincipalFiltro.postSalvarFiltro();

    this.pedidoCompraService.getPedidoCompraLista(this.tabelaPrincipalFiltro.dados).subscribe({
      next: (lista) => {

        this.tabelaPrincipalShowMoreDisable = !lista.hasNext;

        this.tabelaPrincipalItens = this.tabelaPrincipalItens.concat(lista.items);

       }
    })

  }
  novaPedidoCompra(): void{
    this.router.navigateByUrl(`compras/pedido-compra/crud`);
  }

  editarPedidoCompra(row: PedidoCompraListaItem): void{
    this.router.navigateByUrl(`compras/pedido-compra/crud/${row.CC7NUM}`);
  }

  enviarEmailFornecedorOpenModal(row: PedidoCompraListaItem): void{

    this.pcEnviarEmailFornecedor = defaultPedidoCompraEnviarEmailFornecedor();
    this.pcEnviarEmailFornecedor.CC7NUM = row.CC7NUM;

    this.enviarEmailFornecedorModal.open();
  }

  enviarEmailFornecedor():void{
    this.pedidoCompraService.postPedidoCompraEnviaEmailFornecedor(this.pcEnviarEmailFornecedor).subscribe();
  }

  async excluirPedidoCompra(row: PedidoCompraListaItem){

    if (!row.items){
      row.items =  (await firstValueFrom(this.pedidoCompraService.getPedidoCompra(row.CC7NUM, {CSHOWDESCRICAO: 'S'}))).items;
    }

    if (row.items.filter(item=>item.NC7QUJE > 0).length === 0){
      this.poDialogService.confirm({
        title: 'Excluir Pedido de Compra',
        message: `Deseja excluir a Pedido de Compra (${row.CC7NUM}))?`,
        confirm: () => {
          this.pedidoCompraService.deletePedidoCompra(row.CC7NUM).subscribe({
            next: () => {
              this.tabelaPrincipalLoad(true);
            }
          });
        }
      })
    } else {
      this.poNotificationService.error({
        message: `A Pedido de Compra (${row.CC7NUM}) NÃO pode ser excluída.`,
        duration: 5000,
      })
    }
  }

  loadItensPedido(row: PedidoCompraListaItem):void{
    if (!row.items){
      this.pedidoCompraService.getPedidoCompra(row.CC7NUM, {CSHOWDESCRICAO: 'S'}).subscribe({
        next: (pedido) => {
          row.items = pedido.items;
        }
      })
    }
  }

  showDetalhes():boolean{
    return true;
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CC7NUM'    , label: 'Código'      , width: '08%', visible: true},
    {property: 'CC7FORNECE', label: 'Fornecedor'  , width: '10%', visible: true},
    {property: 'CC7LOJA'   , label: 'Loja'        , width: '07%', visible: true},
    {property: 'CA2NOME'   , label: 'Razão Social', width: '30%', visible: true},
    {property: 'CA2CGC'    , label: 'CNPJ'        , width: '10%', visible: true},
    {property: 'DC7EMISSAO', label: 'Emissão'     , width: '10%', visible: true, type: 'date'},
    {property: 'CC7SOLICIT', label: 'Solicitante' , width: '10%', visible: true},
  ]

  public tabelaPrincipalActions: Array<PoTableAction> = [
    { label: 'Editar'  , action: this.editarPedidoCompra.bind(this),    icon: 'po-icon-edit' },
    { label: 'Excluir' , action: this.excluirPedidoCompra.bind(this),   icon: 'po-icon-delete' },
    { label: 'PC Email', action: this.enviarEmailFornecedorOpenModal.bind(this), icon: 'po-icon-mail' },
  ]

  public readonly tabelaPedidoCompraColumns: Array<PoTableColumn> = [
    {property: 'CSITUACAO',label: 'Status',width: '7%', type: 'subtitle', visible: true,
      subtitles: [
        {value: 'B', color: 'color-01', content: 'B', label: 'Bloqueado'},
        {value: 'L', color: 'color-10', content: 'L', label: 'Liberado'},
        {value: 'R', color: 'color-07', content: 'R', label: 'Rejeitado'},
        {value: 'P', color: 'color-03', content: 'P', label: 'Parcialmente Atendido'},
        {value: 'F', color: 'color-12', content: 'F', label: 'Finalizado'},
      ]
    },
    {property: 'CC7ITEM'   , label: 'Item'        , width: '08%', visible: true},
    {property: 'CC7PRODUTO', label: 'Produto'     , width: '10%', visible: true},
    {property: 'CC7DESCRI' , label: 'Descrição'   , width: '30%', visible: true},
    {property: 'CC7OBS'    , label: 'Observação'  , width: '30%', visible: false},
    {property: 'DC7DATPRF' , label: 'Necessidade' , width: '10%', visible: true , type: 'date'},
    {property: 'CC7UM'     , label: 'UM'          , width: '07%', visible: true},
    {property: 'NC7QUANT'  , label: 'Quantidade'  , width: '07%', visible: true , type: 'number', format: '1.4-4'},
    {property: 'NC7QUJE'   , label: 'Entregue'    , width: '07%', visible: true , type: 'number', format: '1.4-4'},
    {property: 'CC7CC'     , label: 'Centro Custo', width: '10%', visible: true},
    {property: 'CC7CONTA'  , label: 'Cta Ctb'     , width: '10%', visible: true},

  ]

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad(true);
    },
    label: 'Aplicar Filtros'
  };

}
